import { render, staticRenderFns } from "./ModalPopupPoints.vue?vue&type=template&id=a8124a58&scoped=true"
import script from "./ModalPopupPoints.vue?vue&type=script&lang=js"
export * from "./ModalPopupPoints.vue?vue&type=script&lang=js"
import style0 from "./ModalPopupPoints.vue?vue&type=style&index=0&id=a8124a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8124a58",
  null
  
)

export default component.exports